export default "__VITE_ASSET__B87fVqZO__"